import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../Hooks/useAuth';

const RequireAuth = ({ allowedRole }) => {
    const { auth } = useAuth();
    const location = useLocation();
    const role = auth?.role || localStorage.userDetails && JSON.parse(localStorage.userDetails).role || false;
    const userID = auth?.userID || localStorage.userID && JSON.parse(localStorage.userID) || false;
    return (
        role === allowedRole
            ? <Outlet />
            : userID
                ? role === "superadmin" 
                        ? <Navigate to="subscription/list" state={{ from: location }} replace/> 
                        : <Navigate to="/" state={{ from: location }} replace/>
                : <Navigate to="/login" state={{ from: location }} replace/>
    );
}

export default RequireAuth;